<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-6">
              </div>
              <div class="col-sm-6">
                <div class="float-sm-end d-flex">
                  <div class="text-sm-right">
                    <button type="button" class="btn btn-success btn-rounded mb-2 mr-2" @click="newBanner()">
                      <i class="mdi mdi-plus mr-1"></i> Novo Banner
                    </button>
                  </div>
                </div>
              </div>
              <!-- end col-->
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead>
                  <tr>
                  <th scope="col" style="width: 20px"></th>
                    <th>Imagem</th>
                    <th>Tempo</th>
                    <th>Ação</th>
                    <th>Status</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <draggable
                  v-model="banners"
                  :element="'tbody'"
                  tag="tbody"
                  :options="{animation:200, handle:'.mover'}"
                >
                  <tr v-for="list in banners" :key="list.id" class="link">
                    <td class="mover">
                      <span class="badge font-size-13 badge-soft-primary p-1 badge-num">{{ list.sequence }}</span>
                    </td>
                    <td class="mover">
                      <img :src="list.url_image" v-if="list.url_image" style="max-height:40px;max-width:80px;object-fit:cover;" />
                    </td>
                    <td class="mover">{{ list.limit_time }}s</td>
                    <td class="mover">{{ list.action }}</td>
                    <td>
                      <b-form-checkbox v-model="list.active" @change="toggleStatus(list.id)" switch size="lg" class="green-custom-check"></b-form-checkbox>
                    </td>
                    <td>
                      <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
                        <template v-slot:button-content>
                          <i class="mdi mdi-dots-horizontal font-size-18"></i>
                        </template>
                        <b-dropdown-item @click="editBanner(list.id)">
                          <i class="fas fa-pencil-alt text-success mr-1"></i> Editar
                        </b-dropdown-item>
                        <b-dropdown-item @click="deleteBanner(list.id)">
                          <i class="fas fa-trash-alt text-danger mr-1"></i> Excluir
                        </b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <modal-form v-model="modalForm" :idBanner="idBanner" ref="formBanner" @created="updateList"></modal-form>
  </Layout>
</template>
<script>
import draggable from 'vuedraggable'
import Swal from 'sweetalert2'
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import ModalForm from './Form'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  components: {
    draggable,
    Layout,
    PageHeader,
    ModalForm
  },
  name: 'lobbybanners',
  page: {
    title: 'Lobby Banners',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      loading: true,
      search: '',
      timeout: null,
      modalForm: false,
      params: {},
      totalRows: 1,
      currentPage: 1,
      idBanner: null,
      perPage: 20,
      submitted: false,
      title: 'Lobby - Banners',
      items: [{
        text: 'Lobby'
      },
      {
        text: 'Banners',
        active: true
      }
      ]
    }
  },
  mounted () {
    this.updateList()
    this.totalRows = this.pagination.total
    this.currentPage = this.pagination.current_page
    this.loading = false
  },
  computed: {
    ...mapGetters('lobbyBanner', { data: 'LOBBYBANNERS' }),
    ...mapState('lobbyBanner', ['pagination']),
    rows () {
      return this.pagination.total
    },
    banners: {
      get () {
        return this.data
      },
      set (value) {
        let loader = this.$loading.show()
        this.updateSequenceAction({ itens: value }).then(res => {
          loader.hide()
          successMessage('Sucesso: Ordem atualizada.', 2500)
        })
      }
    }
  },
  methods: {
    ...mapActions('lobbyBanner', {
      getAll: 'getAll',
      changeStatusAction: 'changeStatus',
      updateSequenceAction: 'orderList',
      destroyAction: 'destroy'
    }),
    newBanner () {
      this.$refs.formBanner.open('')
      this.modalForm = true
    },
    editBanner (id) {
      this.$refs.formBanner.open(id)
      this.modalForm = true
      this.idBanner = id
    },
    async toggleStatus (id) {
      try {
        await this.changeStatusAction(id)
        let message = 'Sucesso: Status atualizado com sucesso.'
        let delay = 2500
        successMessage(message, delay)
        this.updateList()
      } catch (err) {
        console.log(err)
        errorMessage('Alerta: ' + err.response.data.message)
      }
    },
    deleteBanner (id) {
      Swal.fire({
        title: 'Você tem certeza ?',
        text: 'Essa ação não poderá ser revertida',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.destroyAction(id)
            successMessage('Sucesso: Banner excluído com sucesso.', 2500)
            this.updateList()
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    getReport (filter) {
      let params = {
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage,
        status: filter.status || null
      }
      this.params = params
      let loader = this.$loading.show()
      this.getAll(this.params).then((res) => {
        this.totalRows = this.pagination.total
        this.currentPage = this.pagination.current_page
        loader.hide()
      }).catch(error => {
        console.log(error)
        loader.hide()
      })
    },
    updateList () {
      this.getReport(this.params)
    }
  }
}
</script>
<style scoped>
.link { cursor: pointer; }
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { min-height: 300px;}
.float-sm-end { float: right }
</style>
